<template>
  <div class="nutrient-removal-graph">
    <AppParagraph class="removed-text">
      Removed (LB/AC)
    </AppParagraph>
    <div class="nutrient-removal-graph__graph">
      <div
        v-for="nutrient in crop.nutrients"
        :key="nutrient.name"
        class="nutrient-removal-graph__column"
      >
        <AppNutrientBubble :element="nutrient.formula" />
        <div class="nutrient-removal-graph__bar-wrapper">
          <div
            class="nutrient-removal-graph__bar"
            :style="{ height: getNutrientHeight(nutrient) }"
          >
            <div class="nutrient-removal-graph__bar-label">
              <AppHeading size="xs" theme="black" class="nutrient-value">
                {{ getNutrientValue(nutrient) }}
              </AppHeading>
              <span class="nutrient-label">LBS/AC</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AppParagraph size="sm" spacing="xs" theme="gray" class="yield-copy">
      N, P<sub>2</sub>O<sub>5</sub>, K<sub>2</sub>O, and S removal
      coefficients derived from the IPNI Nutrient Removal Calculator as of Jan.
      2018 (http://www.ipni.net/article/IPNI-3346). Mg removal coefficients
      derived from Alabama Extension: ANR-449 (1999), CFI (2001), IPNI (2008),
      North Carolina: AG-439-16 (1991) and other independent sources.
    </AppParagraph>
    <AppParagraph size="sm" theme="gray" class="yield-copy">
      <br /><br />
      *Nutrient removal values may vary regionally depending on growing
      conditions. Use locally available data whenever possible. Crop nutrient
      removal and soil test considerations should be made for proper nutrient
      recommendations.
    </AppParagraph>
  </div>
</template>

<script>
import AppNutrientBubble from '@/components/shared/AppNutrientBubble';
import AppHeading from '@/components/shared/AppHeading';
import AppParagraph from '@/components/shared/AppParagraph';

export default {
  components: {
    AppNutrientBubble,
    AppHeading,
    AppParagraph
  },
  props: {
    crop: {
      type: Object,
      required: true
    },
    yieldPercentage: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isIntialized: false
    };
  },
  computed: {
    maxValue() {
      return Math.max(...this.crop.nutrients.map(n => n.max));
    }
  },
  mounted() {
    setTimeout(() => {
      this.isIntialized = true;
    }, 250);
  },
  methods: {
    getNutrientValue(nutrient) {
      if (!this.isIntialized) {
        return 0;
      }

      const { min, max } = nutrient;
      const value = min + this.yieldPercentage * (max - min);

      return Math.round(value * 10) / 10;
    },
    getNutrientHeight(nutrient) {
      const value = this.getNutrientValue(nutrient);

      return `${(value / this.maxValue) * 100}%`;
    }
  }
};
</script>

<style lang="scss" scoped>
.nutrient-removal-graph {
  &__graph {
    display: flex;
    margin: spacing('lg') 0;

  }

  &__column {
    align-items: center;
    display: flex;
    flex-direction: column;
    width: 25%;
  }

  &__bar-wrapper {
    border-top: solid 1px shade('leaf', 20%);
    display: flex;
    height: 10rem;
    justify-content: center;
    margin-top: spacing('sm');
    width: 100%;

    @include breakpoint('md') {
      height: 20rem;
    }
  }

  &__bar {
    background-color: color('leaf');
    display: flex;
    flex-direction: column;
    height: 0;
    justify-content: flex-end;
    text-align: center;
    transition: height 0.5s;
    width: 90%;
  }

  &__bar-label {
    @include font-size('paragraph', 'xs');
    bottom: -3.5rem;
    position: relative;
  }
  .removed-text {
    font-size: 16px;
    font-family: $inter;
    font-weight: 400;
    line-height: 22px;
  }
  .nutrient-value {
    font-family: $articulat-cf;
    font-size: 14px;
    font-weight: 700;
    line-height: 15px;

    @include breakpoint(md) {
      font-size: 24px;
      font-weight: 700;
      line-height: 25px;
    }
  }
  .nutrient-label {
    font-size: 8px;
    font-family: $inter;
    font-weight: 400;
    line-height: 18px;

    @include breakpoint(md) {
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
    }
  }
  .yield-copy {
    color: rgb(124 124 124 / 60%);
    font-size: 14px;
    font-family: $inter;
    font-weight: 400;
    line-height: 20px;
    text-align: center;

   @include breakpoint(md) {
      display: none;      
    }
  }
}
</style>
